import type React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGoal } from "@/hooks/useGoal";
import { goalService } from "@/services/goalService";
import type { Goal } from "@/types/goal";
import GoalForm from "./components/GoalForm";

const GoalFormPage: React.FC = () => {
	const { goalId } = useParams<{ goalId?: string }>();
	const navigate = useNavigate();
	const { goal, loading, error } = useGoal(goalId);

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;

	const handleSubmit = async (
		formData: Omit<Goal, "id" | "userId" | "createdAt" | "updatedAt">,
	) => {
		try {
			if (goalId) {
				await goalService.updateGoal(goalId, formData);
			} else {
				await goalService.createGoal(formData);
			}
			navigate("/webapp/goals");
		} catch (err) {
			console.error("目標の保存に失敗しました:", err);
			alert("目標の保存に失敗しました。");
		}
	};

	const initialData = goal
		? {
				title: goal.title,
				description: goal.description,
				category: goal.category,
				startDate: goal.startDate,
				endDate: goal.endDate,
				priority: goal.priority,
				status: goal.status,
			}
		: undefined;

	return (
		<div className="container mx-auto px-4 py-8">
			<h1 className="text-3xl font-bold mb-6">
				{goalId ? "目標編集" : "新しい目標"}
			</h1>
			<GoalForm initialData={initialData} onSubmit={handleSubmit} />
		</div>
	);
};

export default GoalFormPage;
